import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { spaceForBaseSpaceQuery } from './queries/spaceForBaseSpace.graphql';
import type {
	spaceForBaseSpaceQuery as spaceForBaseSpaceQueryType,
	spaceForBaseSpaceQueryVariables as spaceForBaseSpaceQueryVariablesType,
} from './queries/__types__/spaceForBaseSpaceQuery';

export function preloadSpace(spaceKey: spaceForBaseSpaceQueryVariablesType['spaceKey']) {
	return query<spaceForBaseSpaceQueryType, spaceForBaseSpaceQueryVariablesType>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: spaceForBaseSpaceQuery,
		variables: {
			spaceKey,
		},
	});
}
